import { render } from "./ValidateInput2.vue?vue&type=template&id=654261de"
import script from "./ValidateInput2.vue?vue&type=script&lang=js"
export * from "./ValidateInput2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/store/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__